import { toast, Bounce } from 'react-toastify';

const toastNotification = (type, msg) => {
	toast(msg, {
		transition: Bounce,
		closeButton: true,
		autoClose: 5000,
		position: 'bottom-center',
		type: type
	});
};

export default toastNotification;
